import CONSTANTS from '@/constants'
import cloneDeep from 'lodash/cloneDeep'

const {
  PLANS,
  VOUCHERS,
  LEAP_YEAR_PROMO_PRODUCT_BUNDLES: { INE_LEAP_YEAR_BUNDLE },
} = CONSTANTS
const {
  ANNUAL,
  BAH,
  PREMIUM,
  EDA_PREMIUM,
  MONTHLY,
  MONTHLY_EJPT,
  PREMIUM2YR,
  PREMIUM_MONTHLY,
  EWPT_PREMIUM,
  SKILL_DIVE_ANNUAL,
  ECPPT_PREMIUM,
  EWPTX_PREMIUM,
  EMAPT_PREMIUM,
  ECTHP_PREMIUM,
  ECIR_PREMIUM,
  EJDS_PREMIUM,
  ESOC_PREMIUM,
  EAIS_PREMIUM,
  EJPT_FUNDAMENTALS,
  PREMIUM_PLUS,
} = PLANS

const FUNDAMENTALS_VOUCHER_OPTIONS = [
  {
    merchant_id: VOUCHERS.EJPT,
    name: 'eJPT',
  },
  {
    merchant_id: VOUCHERS.ICCA,
    name: 'ICCA',
  },
]

export const availablePlansHydratation = (
  context,
  availablePlansCollection,
  skillDiveCollection
) => {
  const fallback = Object.values(CONSTANTS.PLANS)
  const requestedPlans = new URLSearchParams(window.location.search).get('available_plans')
  const matches =
    requestedPlans && requestedPlans.length
      ? requestedPlans
          .split(',')
          .map(name => name.trim())
          .filter(name => fallback.includes(name))
      : []
  const cleanNames = matches && matches.length ? matches : fallback

  let subscriptionFiltered = availablePlansCollection
  if (requestedPlans?.includes(BAH)) {
    context.commit('ONE_EXCLUSIVE_PLAN_UPDATED', true)
    subscriptionFiltered = subscriptionFiltered.filter(plan => {
      plan.product_type = 'plan'
      return plan.merchant_id === BAH
    })
  }

  return Object.values(subscriptionFiltered)
    .map(current => {
      current.product_type = 'plan'
      const cloneCurrent = cloneDeep(current)
      // plan term prop hydratation
      switch (current.merchant_id) {
        case MONTHLY:
        case PREMIUM_MONTHLY:
        case MONTHLY_EJPT:
          current.term = 'month'
          break
        case PREMIUM2YR:
          current.term = '2 year'
          break
        default:
          current.term = 'year'
          break
      }
      switch (current.merchant_id) {
        case MONTHLY:
          current.text = 'Limited Introductory Content'
          current.tooltip = 'Over 200 hours of novice level<br/>content across 7 learning path'
          current.subtitle = {
            text: 'Limited Introductory Content',
            color: 'var(--light-orange)',
          }
          current.link = 'https://ine.com/faqs/subscriptions/fundamentals'
          break
        case ANNUAL:
          current.text = 'Limited Introductory Content'
          current.textLeapYearPage = `<div class="plan-row-item__bottom-highlight">
              <div>Introductory Content <span class="plan-row-item__header-text--fundamentals-annual">Choose one voucher (eJPT or ICCA)</span></div>
              <div class="plan-row-item__bottom-highlight--you-save"><strong>YOU SAVE $100</strong></div>
            </div>`
          current.tooltip = 'Over 200 hours of novice level<br/>content across 7 learning paths'
          current.subtitle = {
            text: 'Limited Introductory Content',
            color: 'var(--light-orange)',
          }
          current.infoTitle = {
            label: 'FREE',
            text: 'eJPT or ICCA Voucher',
          }
          current.link = 'https://ine.com/faqs/subscriptions/fundamentals'
          current.voucherSelection = {
            required: true,
            options: FUNDAMENTALS_VOUCHER_OPTIONS,
            fulfillment: 'hubspot',
            instructions: 'Voucher code delivered via email after checkout.',
          }
          break
        case PREMIUM:
          current.text = 'Entire Content Library'
          current.tooltip =
            'Over 3500 hours of content across <br/>70+ learning paths for all skill levels;<br/><span style="color:#f8b369">Skill Dive not included</span>'
          current.subtitle = {
            text: 'Entire Content Library',
            color: 'var(--strong-light-green-b5)',
          }
          current.infoTitle = {
            label: 'Free',
            text: 'Yearly INE Certification Voucher',
          }
          current.voucherBenefit = {
            includesVoucher: true,
            fulfillment: 'hubspot',
          }
          current.link = 'https://ine.com/faqs/subscriptions/premium'
          break
        case PREMIUM_PLUS:
          current.text = 'Entire Content Library + Skill Dive'
          current.tooltip =
            'Over 3500 hours of content across<br/>70+ learning paths for all skill levels;<br/><span style="color:#b5ffe9">Skill Dive included</span>'
          current.subtitle = {
            text: 'Entire Content Library + <b>Skill Dive</b>',
            color: 'var(--strong-light-green-b5)',
          }
          current.infoTitle = {
            label: 'Free',
            text: 'Yearly INE Certification Voucher',
          }
          current.voucherBenefit = {
            includesVoucher: true,
            fulfillment: 'hubspot',
          }
          current.link = 'https://info.ine.com/premium-plus/'
          current.addOns = skillDiveCollection
          current.priceToShow = cloneCurrent.price_cents + skillDiveCollection[0].price_cents
          current.priceToShowTeams = cloneCurrent.price_cents + skillDiveCollection[0].price_cents
          current.addOnsOnCart = []
          current.discounted_price_cents = cloneCurrent.discounted_price_cents
          current.discountedPriceToShow =
            cloneCurrent.discounted_price_cents + skillDiveCollection[0].price_cents
          break
        case BAH:
          current.text = 'Entire Content Library'
          current.tooltip = ''
          current.subtitle = {
            text: '',
            color: '',
          }
          current.infoTitle = {
            label: null,
            text: 'Annual Voucher Discount',
          }
          current.link = 'https://ine.com/faqs/subscriptions/premium'
          break
        case INE_LEAP_YEAR_BUNDLE:
          current.text =
            '<div class="plan-row-item__bottom-highlight--you-save"><strong>YOU SAVE $500</strong></div>'
          break
        default:
          current.text = false
          current.link = false
          break
      }
      // plan details hydratation
      switch (current.merchant_id) {
        case MONTHLY_EJPT:
        case EJPT_FUNDAMENTALS:
          current.badge = 'ejpt_badge'
          current.nameToShow = 'Junior Penetration Tester Exam Voucher'
          current.nameShort = 'eJPT'
          current.promoInfo = {
            title: '+ 3 months of Fundamentals*',
            mobile: '+3 mo Fundamentals FREE*',
            desktop: '+3 months of Fundamentals FREE*',
          }
          current.promoInfoExtra =
            '*After 3 months, this subscription will be upgraded to Annual Premium + Free Certification. You will be charged $350 ($150 in savings) at this time unless canceled prior.'
          current.alreadyINE = 'an INE'
          current.bestValue = '+3 months of Fundamentals'
          current.bundleShortInfo = 'eJPT+ 3 months of Fundamentals'
          break
        case EDA_PREMIUM:
          current.badge = 'eEDA_badge'
          current.nameToShow = 'Enterprise Defense Associate Exam Voucher'
          current.nameShort = 'eEDA'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.alreadyINE = 'a Premium'
          current.bestValue = '+3 months of Premium'
          current.bundleShortInfo = 'eEDA+ 3 months of Premium'
          break
        case EWPT_PREMIUM:
          current.badge = 'eWPT_badge'
          current.nameToShow = 'Web Application Penetration Tester Exam Voucher'
          current.nameShort = 'eWPT'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.alreadyINE = 'a Premium'
          current.bestValue = ''
          current.bundleShortInfo = 'eWPT+ 3 months of Premium'
          break
        case EWPTX_PREMIUM:
          current.nameToShow = 'eWPTX'
          current.nameShort = 'eWPTX'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eWPTX+ 3 months of Premium'
          break
        case EMAPT_PREMIUM:
          current.nameToShow = 'eMAPT'
          current.nameShort = 'eMAPT'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eMAPT+ 3 months of Premium'
          break
        case ECTHP_PREMIUM:
          current.nameToShow = 'eCTHP'
          current.nameShort = 'eCTHP'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eCTHP+ 3 months of Premium'
          break
        case SKILL_DIVE_ANNUAL:
          // price_cents --> base plan price
          // discounted_price_cents --> base plan price with discount
          // skillDiveCollection --> SD addOns
          // SD price is (base plan price + 1 addOn)
          current.totalHours = 240
          current.addOns = skillDiveCollection
          current.priceToShow = cloneCurrent.price_cents + skillDiveCollection[0].price_cents
          current.priceToShowTeams = cloneCurrent.price_cents + 4900
          current.addOnsOnCart = []
          current.discounted_price_cents = cloneCurrent.discounted_price_cents
          current.discountedPriceToShow =
            cloneCurrent.discounted_price_cents + skillDiveCollection[0].price_cents
          break
        case ECPPT_PREMIUM:
          current.nameToShow = 'eCPPT'
          current.nameShort = 'eCPPT'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eCPPT + 3 months of Premium'
          break
        case ECIR_PREMIUM:
          current.nameToShow = 'eCIR'
          current.nameShort = 'eCIR'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eCIR + 3 months of Premium'
          break
        case EJDS_PREMIUM:
          current.nameToShow = 'eJDS'
          current.nameShort = 'eJDS'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eJDS + 3 months of Premium'
          break
        case ESOC_PREMIUM:
          current.nameToShow = 'Security Operations Certified Exam Voucher'
          current.nameShort = 'eSOC'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eSOC + 3 months of Premium'
          break
        case EAIS_PREMIUM:
          current.nameToShow = 'AI Systems Security Specialist Exam Voucher'
          current.nameShort = 'eAIS'
          current.alreadyINE = 'a Premium'
          current.promoInfo = {
            title: '+ 3 months of Premium*',
            mobile: '+ 3 mo of Premium FREE*',
            desktop: '+ 3 months of Premium FREE*',
          }
          current.promoInfoExtra =
            '*Renewal: $350 after 3 months, then $799 annually from purchase date.'
          current.bundleShortInfo = 'eAIS + 3 months of Premium'
          break
        case ANNUAL:
          current.user_saves_price_cents = current.price_cents - current.discounted_price_cents
          break
        default:
          break
      }
      return current
    })
    .filter(plan => plan.merchant_id && cleanNames.includes(plan.merchant_id))
}
